namespace SPA {
	export namespace Realtor {
		// import ResponseObject = Wollmilch.ResponseObject;
		export class List extends ui.tab.TabHTMLPresentation {
			private m_List: SPA.gui.Listing<SPA.Realtor.RealtorObjectModel>;
			private m_Data: SPA.Realtor.RealtorObjectModel[][];

			private Events: Backbone.Events;

			public constructor() {
				super();

				this.Events = Backbone.Events;
				this.Events.listenTo(app.getObjectManager().getList(), 'change sync', (data: SPA.Realtor.ObjectList) => {
					this.empty().append(
						this.rebuild(this)
						);
				});

				this.m_Data = [];

				this.m_List = new SPA.gui.Listing<SPA.Realtor.RealtorObjectModel>(
					new SPA.Realtor.data.RealtorTableDataModel(
						{
							header: true,
							headerEnd: true,
							style:
								{
									condense: true,
									stripes: true,
									hover: true
								}
						}
					),
					50,
					this.dataModelLoadingFunction
				);
			}

			public rebuild(root: ui.base.BaseHTMLElement): List
			{
				// @Todo remove unneeded div nesting - cosmetic!
				root.empty();
				this.appendTo(root)
					.append(this.buildNavbar());

				this.m_List.rebuild(new ui.Box.Box().addClass('table-wrapper hidden').appendTo(this));

				// Wait for first incoming data or use existing information
				if (app.getObjectManager().getList().length > 0)
				{
					this.append(this.buildHtml());
				}
				$('.statusFilter').trigger('change');

				return this;
			}

			private dataModelLoadingFunction(list: SPA.gui.Listing<SPA.Realtor.RealtorObjectModel>, count: number, page: number): void {
				count = clamp(count, 5, 50);

				const idx = this.m_Data.findIndex((value, index) => index === page && value !== undefined);

				if (idx > -1) {
					list.Content().Data(this.m_Data[idx]);
					list.Content().rebuild();

					return;
				}

				const listener = Backbone.Events;
				listener.listenTo(app.getObjectManager().getList(), 'sync', (data: SPA.Realtor.ObjectList) => {

					list.Content().Data(data.models);
					list.Content().rebuild();

					list.SetPage(page, count);

					this.m_Data[page] = data.models;
				});
			}

			private buildNavbar(): JQuery {
				const navbar = ui.$$.nav().addClass('row navbar navbar-default').attr('style', 'padding: 0 10px; margin: 0');

				const viewToolbar = ui.$$.div().addClass('col-sm-2 btn-group navbar-left hidden-xs').attr('role', 'group').attr('style', 'margin: 8px 0')
					//
					// .append(
					// 	$('<button type="button" class="btn btn-default"><i class="fas fa-bars"></i></button>')
					// 		.on('click', (e) => {
					// 			$(e.currentTarget).parent().find('button').removeClass('active');
					// 			$(e.currentTarget).addClass('active');
					// 			$('.tile.wrapper').addClass('hidden');
					// 			$('.smallrow-wrapper').addClass('hidden');
					// 			$('.table-wrapper').removeClass('hidden');
					// 		})
					// )
					.append(
						$('<button type="button" class="btn btn-default" style="margin-bottom: 6px;"><i class="fas fa-th-list"></i></button>')
							.on('click', (e) => {
								$(e.currentTarget).parent().find('button').removeClass('active');
								$(e.currentTarget).addClass('active');
								$('.tile.wrapper').addClass('hidden');
								$('.smallrow-wrapper').removeClass('hidden');
								$('.table-wrapper').addClass('hidden');
							})
					)
					.append($('<button type="button" class="btn btn-default active"><i class="fas fa-th-large"></i></button>')
						.on('click', (e) => {
							$(e.currentTarget).parent().find('button').removeClass('active');
							$(e.currentTarget).addClass('active');
							$('.tile.wrapper').removeClass('hidden');
							$('.smallrow-wrapper').addClass('hidden');
							$('.table-wrapper').addClass('hidden');
						})
					);

				const searchInput = $('<input type="text" class="form-control" placeholder="Objekte suchen" style="width: 300px"/>')
					.on('keyup', (e) => {
						const input = e.currentTarget as HTMLInputElement;
						const searchParts = input.value.trim().toLowerCase().split(' ');

						// Filter Table results
						$('.table-wrapper table tr').each((idx, el) => {
							let searchmatch: boolean = true;

							for (const search of searchParts) {
								let colmatch: boolean = false;

								$(el).find('td').each((idxel, tdel) => {
									colmatch = colmatch || $(tdel).text().toLowerCase().indexOf(search) !== -1;
								});
								searchmatch = searchmatch && colmatch;
							}

							$(el).toggle(searchmatch);
						});

						// Filter small row results
						$('.smallrow-wrapper .object').each((idx, el) => {
							let searchmatch: boolean = true;

							const objectString = $(el).text().toLowerCase().replace(/[\.\,\-²€]/g, '').replace(/\s{2,}/g, ' ');

							for (const search of searchParts) {
								let colmatch: boolean = false;

								for (const boxParts of objectString.split(' ')) {
									colmatch = colmatch || boxParts.indexOf(search) !== -1;
								}
								searchmatch = searchmatch && colmatch;
							}

							$(el).toggle(searchmatch);
						});

						// Filter Grid results
						$('.tile.wrapper .object').each((idx, el) => {
							let searchmatch: boolean = true;

							const objectString = $(el).text().toLowerCase().replace(/[\.\,\-²€]/g, '').replace(/\s{2,}/g, ' ');

							for (const search of searchParts) {
								let colmatch: boolean = false;

								for (const boxParts of objectString.split(' ')) {
									colmatch = colmatch || boxParts.indexOf(search) !== -1;
								}
								searchmatch = searchmatch && colmatch;
							}

							$(el).toggle(searchmatch);
						});
					});

				const inputStreetSearch = $('<div class="search-input input-group hidden-xs">')
					.append('<input type="text" class="form-control" placeholder="Straße suchen" style="width: 165px"/>')
					.append('<div class="input-group-addon"><i class="fas fa-times"></i></div>')
					.on('keyup', (e) => {
						const input = e.target as HTMLInputElement;
						const searchParts = input.value.trim().toLowerCase().split(' ');

						if ( searchParts[0].length === 0 ){
							$('.statusFilter').trigger('change');
							return;
						}

						const objectList = app.getObjectManager().getList().models;

						_.each(objectList, (object, index) => {
							let match: boolean = true;

							for (const search of searchParts) {
								let partialMatch: boolean = false;

								partialMatch = partialMatch || object.Address.Street.toLowerCase().indexOf(search) !== -1;

								match = match && partialMatch;
							}

							// Filter results
							$('.table-wrapper table tr').eq(index).toggle(match);
							$('.smallrow-wrapper .object').eq(index).toggle(match);
							$('.tile.wrapper .object').eq(index).toggle(match);
						});
					});

				const inputCitySearch = $('<div class="search-input input-group hidden-xs">')
					.append('<input type="text" class="form-control" placeholder="PLZ, Ort suchen" style="width: 150px"/>')
					.append('<div class="input-group-addon"><i class="fas fa-times"></i></div>')
					.on('keyup', (e) => {
						const input = e.target as HTMLInputElement;
						const searchParts = input.value.trim().toLowerCase().split(' ');

						if ( searchParts[0].length === 0 ){
							$('.statusFilter').trigger('change');
							return;
						}

						const objectList = app.getObjectManager().getList().models;

						_.each(objectList, (object, index) => {
							let match: boolean = true;

							for (const search of searchParts) {
								let partialMatch: boolean = false;

								// PostalCode or City Name?
								if (search.match(/\d+/)) {
									partialMatch = partialMatch || object.Address.PostalCode.indexOf(search) === 0;
								} else {
									partialMatch = partialMatch || object.Address.City.toLowerCase().indexOf(search) !== -1;
								}

								match = match && partialMatch;
							}

							// Filter results
							$('.table-wrapper table tr').eq(index).toggle(match);
							$('.smallrow-wrapper .object').eq(index).toggle(match);
							$('.tile.wrapper .object').eq(index).toggle(match);
						});
					});

				const priceSearch = $('<div class="search-input input-group hidden-xs hidden-sm hidden-md">')
					.append('<input class="form-control" placeholder="Preis" style="width: 120px; text-align: right">')
					.append('<div class="input-group-addon">€</div>')
					.append('<div class="input-group-addon"><i class="fas fa-times"></i></div>')
					.on('keyup', (e) => {
						const input = e.target as HTMLInputElement;

						// remove white-spaces and non-digits (except -)
						input.value = input.value.replace(' ', '').replace(/[^\d\-]/, '');

						const rangeParts = input.value.trim().toLowerCase().split('-');

						if ( rangeParts[0].length === 0 ){
							$('.statusFilter').trigger('change');
							return;
						}

						const objectList = app.getObjectManager().getList().models;

						_.each(objectList, (object, index) => {
							let match: boolean = true;
							const wf = object.Data.general.price.value;
							// const wf = object.Data.property.area.building + object.Data.property.area.garden;

							let price0 = 0;
							if (rangeParts.length === 1 && rangeParts[0] !== '') {
								price0 = parseInt(rangeParts[0], 10);

								if (price0 <= 1000)
								{
									price0 *= 1000;
								}
								match = wf === price0;
							}

							let price1 = 0;
							if (rangeParts.length === 2) {
								price1 = parseInt(rangeParts[1], 10);
								if (price1 <= 1000) {
									price1 *= 1000;
								}
								match = wf >= price0 && wf <= price1;
							}

							// Filter results
							$('.table-wrapper table tr').eq(index).toggle(match);
							$('.smallrow-wrapper .object').eq(index).toggle(match);
							$('.tile.wrapper .object').eq(index).toggle(match);
						});
					});

				// const wfSearch = $('<div class="search-input input-group hidden-xs">')
				// 	.append('<input class="form-control" placeholder="Wohnfläche" style="width: 120px; text-align: right">')
				// 	.append('<div class="input-group-addon">m²</div>')
				// 	.append('<div class="input-group-addon"><i class="fas fa-times"></i></div>')
				// 	.on('keyup', (e) => {
				// 		const input = e.target as HTMLInputElement;

				// 		// remove white-spaces and non-digits (except -)
				// 		input.value = input.value.replace(' ', '').replace(/[^\d\-]/, '');

				// 		const rangeParts = input.value.trim().toLowerCase().split('-');

				// 		if ( rangeParts[0].length === 0 ){
				// 			$('.statusFilter').trigger('change');
				// 			return;
				// 		}

				// 		const objectList = app.getObjectManager().getList().models;

				// 		_.each(objectList, (object, index) => {
				// 			let match: boolean = true;

				// 			const wf = object.Data.details.living_area.value;
				// 			// const wf = object.Data.property.area.building + object.Data.property.area.garden;

				// 			if (rangeParts.length === 1 && rangeParts[0] !== '') {
				// 				match = wf === parseInt(rangeParts[0], 10);
				// 			} else if (rangeParts.length === 2) {
				// 				match = wf >= parseInt(rangeParts[0], 10) && wf <= parseInt(rangeParts[1], 10);
				// 			}

				// 			// Filter results
				// 			$('.table-wrapper table tr').eq(index).toggle(match);
				// 			$('.smallrow-wrapper .object').eq(index).toggle(match);
				// 			$('.tile.wrapper .object').eq(index).toggle(match);
				// 		});
				// 	});

				// const gfSearch = $('<div class="search-input input-group hidden-xs">')
				// 	.append('<input class="form-control" placeholder="Grundfläche" style="width: 120px; text-align: right">')
				// 	.append('<div class="input-group-addon">m²</div>')
				// 	.append('<div class="input-group-addon"><i class="fas fa-times"></i></div>')
				// 	.on('keyup', (e) => {
				// 		const input = e.target as HTMLInputElement;

				// 		// remove white-spaces and non-digits (except -)
				// 		input.value = input.value.replace(' ', '').replace(/[^\d\-]/, '');

				// 		const rangeParts = input.value.trim().toLowerCase().split('-');

				// 		if ( rangeParts[0].length === 0 ){
				// 			$('.statusFilter').trigger('change');
				// 			return;
				// 		}

				// 		const objectList = app.getObjectManager().getList().models;

				// 		_.each(objectList, (object, index) => {
				// 			let match: boolean = true;

				// 			const gf = object.Data.property.area.building + object.Data.property.area.garden;

				// 			if (rangeParts.length === 1 && rangeParts[0] !== '') {
				// 				match = gf === parseInt(rangeParts[0], 10);
				// 			} else if (rangeParts.length === 2) {
				// 				match = gf >= parseInt(rangeParts[0], 10) && gf <= parseInt(rangeParts[1], 10);
				// 			}

				// 			// Filter results
				// 			$('.table-wrapper table tr').eq(index).toggle(match);
				// 			$('.smallrow-wrapper .object').eq(index).toggle(match);
				// 			$('.tile.wrapper .object').eq(index).toggle(match);
				// 		});
				// 	});

				const statusDropdown = $('<select class="statusFilter"></select>')
					.append('<option value="Aktiv" selected>Aktive Objekte</option>')
					.append('<option value="Inaktiv">Inaktive Objekte</option>')
					.append('<option value="Verkauft">Verkaufte Objekte</option>')
					.on('change', () => {
						let match: boolean;
						const inputValue = $('.statusFilter').val();
						const objectList = app.getObjectManager().getList().models;

						_.each(objectList, (object, index) => {
							match = false;
							const oStatus = SPA.types.InActive[
								object.attributes.AdvData.active as keyof typeof SPA.types.InActive
							];
							if (inputValue === oStatus) {
								match = true;
							}

							// Filter results
							$('.table-wrapper table tr').eq(index).toggle(match);
							$('.smallrow-wrapper .object').eq(index).toggle(match);
							$('.tile.wrapper .object').eq(index).toggle(match);

						});
					});


				const objectSearch = $('<form class="navbar-form navbar-left" style="width: 100%;">')
					// .append(priceSearch)
					// .append(priceSearch)
					.append(inputStreetSearch)
					.append(inputCitySearch)
					// .append(wfSearch)
					// .append(gfSearch)
					.append(statusDropdown);

				const formdiv = $('<div class="col-sm-10">')
					.append(objectSearch);

				// const bidderFilter = $('<form class="navbar-form navbar-left">')
				// 	.append(
				// 		ui.$$.div().addClass('input-group')
				// 			.append(
				// 				$('<label></label>')
				// 					.append('<input type="checkbox" style="vertical-align: middle" value="" />')
				// 					.append('<span style="font-weight: normal;position: relative;top: 2px; padding-left: 5px">nur mit Kaufinteressenten</span>')
				// 			)
				// 	);

				$('body').on('click', '.navbar-form .fa-times', (e) => {
					const input = $(e.target).closest('.input-group').find('input');
					input.val('').trigger('keyup');
				});

				navbar.append(viewToolbar)
					.append(formdiv);
					// .append(bidderFilter);

				return navbar;
			}

			private buildHtml() {
				const objectList = app.getObjectManager().getList();
				const boxHtml = $('<div class="tile wrapper"></div>');
				const rowHtml = $('<div class="smallrow-wrapper hidden"></div>');

				for (const object of objectList.models) {
					const objectBox = Realtor.List.ObjectBox(object);
					boxHtml.append(objectBox);

					const objectRow = Realtor.List.ObjectRow(object);
					rowHtml.append(objectRow);
				}

				return boxHtml.add(rowHtml);
			}

			public static ObjectRow(object: RealtorObjectModel): JQuery
			{
				let mainImage = 'assets/images/placeholder-image.png';
				if (object.MainImage)
				{
					mainImage = object.MainImage;
					if (mainImage.indexOf('http') !== 0)
					{
						mainImage = app.getRemotePath() + mainImage;
					}
				}
				const createDate = moment(new Date(object.CreatedAt.date)).format('DD.MM.YYYY');
				const askingPrince = object.AdvData && object.AdvData.price
					? accounting.formatMoney(object.AdvData.price) + ' €'
					: object.Data.general && object.Data.general.price.value
					? accounting.formatMoney(object.Data.general.price.value) + ' €'
					: '(ohne Preis)';

				console.log(object.AdvData);
				// const status =

				const objectRow = $(`<div class="box object object-${object.Object.ID}">
						<div class="flex-8 preview-image">
							<img src="${mainImage}" alt="" />
						</div>
						<div class="address flex-15">
							<div class="address-city">${object.Address.PostalCode} ${object.Address.City}</div>
							<div class="address-street">${object.Address.Street} ${object.Address.HouseNumber}</div>
						</div>
						<div class="asking-price flex-10">
							<span>${askingPrince}</span>
						</div>
						<div class="flex-15">
							<div class="subtitle object-seller">
								<span>${object.Owner ? object.Owner.Name : ''} ${object.Owner ? object.Owner.Surname : ''}</span>
							</div>
							<div class="tag objectid">
								${object.ObjectNumber}
							</div>
						</div>
						<div class="housetype flex-10">${object.Data.common ? SPA.types.Object.Type[object.Data.common.type.type] : ''}</div>
						<div class="flex-5 interest">
<!--							<i class="fas fa-users"></i>-->
							<span>${createDate}</span>
						</div>
						<div class="flex-8">
							<i class="fas fa-ruler-combined" title="Grundstück"></i>
							<span>${object.Data.property ? object.Data.property.area.building + object.Data.property.area.garden : ''} m²</span>
						</div>
						<div class="flex-8">
							<i class="fas fa-home" title="Wohnfläche"></i>
							<span>${object.Data.details ? object.Data.details.living_area.value : ''} m²</span>
						</div>
						<div class="flex-5">
							<i class="fab fa-buromobelexperte" title="Anzahl Zimmer"></i>
							<span>${object.AdvData.rooms || '-'}</span>
						</div>
						<div class="flex-5">
							<i class="fas fa-bath" title="Badezimmer"></i>
							<span>${object.AdvData.bathroom_count || '-'}</span>
						</div>
						<div class="flex-5">
							<i class="fas fa-bed" title="Schlafzimmer"></i>
							<span>${object.AdvData.bedroom_count || '-'}</span>
						</div>
						<div class="flex-5">
							<i class="fas fa-shapes" title="Kinderzimmer"></i>
							<span>${object.AdvData.childroom_count || '-'}</span>
						</div>
					</div>`);

				objectRow.on('click', (e) => {
					app.getGlobalTabControl().addTab(
						object.ObjectNumber,
						new SPA.Realtor.Page(object),
						true
					);
				});

				return objectRow;

			}

			public static ObjectBox(object: RealtorObjectModel): JQuery {
				let mainImage = 'assets/images/placeholder-image.png';
				if (object.MainImage)
				{
					mainImage = object.MainImage;
					if (mainImage.indexOf('http') !== 0) {
						mainImage = app.getRemotePath() + mainImage;
					}
				}
				const createDate = moment(new Date(object.CreatedAt.date)).format('DD.MM.YYYY');
				const askingPrince = object.AdvData && object.AdvData.price
					? accounting.formatMoney(object.AdvData.price) + ' €'
					: object.Data.general && object.Data.general.price.value
						? accounting.formatMoney(object.Data.general.price.value) + ' €'
						: '(ohne Preis)';

				const box = $(`<div class="box object object-${object.Object.ID}">
						<div class="preview-image">
							<div class="bar bar-top">
								<div class="address">${object.Address.PostalCode} ${object.Address.City}</div>
								<div class="asking-price">${askingPrince}</div>
							</div>
							<img src="${mainImage}" alt="" />
						</div>
						<div class="object-details">
							<div class="tagcloud">
								<div class="tag housetype">${object.Data.common ? SPA.types.Object.Type[object.Data.common.type.type] : ''}</div>
								<div class="tag objectid">${object.ObjectNumber}</div>
								<div class="tag interest">
<!--									<i class="fas fa-users"></i> -->
									<span>${createDate}</span>
								</div>
							</div>

							<div class="description">
								<div class="title address-street">${object.Address.Street} ${object.Address.HouseNumber}</div>
								<div class="subtitle object-seller">
									<span>${object.Owner ? object.Owner.Name : ''} ${object.Owner ? object.Owner.Surname : ''}</span>
								</div>
							</div>

							<div class="features-grid">
								<div class="grid-row">
									<div>
										<i class="fas fa-ruler-combined" title="Grundstück"></i>
										<span>${object.Data.property ? object.Data.property.area.building + object.Data.property.area.garden: ''} m²</span>
									</div>
									<div>
										<i class="fas fa-home" title="Wohnfläche"></i>
										<span>${object.Data.details ? object.Data.details.living_area.value : ''} m²</span>
									</div>
									<div>
										<i class="fab fa-buromobelexperte" title="Anzahl Zimmer"></i>
										<span>${object.AdvData ? object.AdvData.rooms || '-' : '-'}</span>
									</div>
								</div>

								<div class="grid-row">
									<div>
										<i class="fas fa-bath" title="Badezimmer"></i>
										<span>${object.AdvData ? object.AdvData.bathroom_count || '-' : '-'}</span>
									</div>
									<div>
										<i class="fas fa-bed" title="Schlafzimmer"></i>
										<span>${object.AdvData ? object.AdvData.bedroom_count || '-' : '-'}</span>
									</div>
									<div>
										<i class="fas fa-shapes" title="Kinderzimmer"></i>
										<span>${object.AdvData ? object.AdvData.childroom_count || '-' : '-'}</span>
									</div>
								</div>
							</div>
						</div>
					</div>`);

				box.on('click', (e) => {
					app.getGlobalTabControl().addTab(
						object.ObjectNumber,
						new SPA.Realtor.Page(object),
						true
						);
				});

				return box;
			}
		}
	}
}
